import React from 'react';
import PropTypes from 'prop-types';

import {black500} from "assets/jss/main";

DataLine.propTypes = {
    label: PropTypes.string.isRequired,
    value: PropTypes.any.isRequired
};

function DataLine({label, value}) {
    return (
        <div style={{display: 'flex', justifyContent: 'space-between', fontSize: '14px'}}>
            <div style={{color: '#6b7280'}}>
                {label}
            </div>
            <div style={{color: black500}}>
                {value}
            </div>
        </div>
    );
}

export default DataLine;
